import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { NumberConstants, Notifications } from '../../../../configs/app.config';

@Component({
  selector: 'sra-input-field',
  templateUrl: './input-field.component.html',
  styleUrls: ['./input-field.component.scss'],
})
export class InputFieldComponent implements OnChanges, AfterViewInit {
  @Input() id: string | undefined = undefined;
  @Input() type: string | undefined = undefined;
  @Input() placeholder: string | undefined = undefined;
  @Input() disabled = false;
  @Input() customClass: string | undefined = undefined;
  @Input() value?: string;
  @Input() maxLength?: number;
  @Input() showCharCount = false;
  @Output() userInput = new EventEmitter<string>();
  @Output() validationStatus = new EventEmitter<boolean>();

  numberConstants = NumberConstants;
  currentLength = 0;

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.currentLength = input.value.length;
    this.userInput.emit(input.value);
    this.validationStatus.emit(!this.isAtLimit);
  }

  get maxLengthValue(): number {
    return this.maxLength ?? this.numberConstants.MAX_NOTES_LENGTH;
  }

  get isAtLimit(): boolean {
    return this.currentLength > this.maxLengthValue;
  }

  get validationMessage(): string {
    return Notifications.CHARACTER_LIMIT_EXCEEDED.replace('{0}', this.maxLengthValue.toString());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value'] && changes['value'].currentValue !== undefined) {
      this.currentLength = changes['value'].currentValue?.length ?? 0;
      this.validationStatus.emit(!this.isAtLimit);
    }
  }

  ngAfterViewInit(): void {
    this.currentLength = this.value?.length ?? 0;
  }

}
